import { render, staticRenderFns } from "./CustomService.vue?vue&type=template&id=437dca3f&scoped=true"
import script from "./CustomService.vue?vue&type=script&lang=js"
export * from "./CustomService.vue?vue&type=script&lang=js"
import style0 from "./CustomService.vue?vue&type=style&index=0&id=437dca3f&prod&scoped=true&lang=css"
import style1 from "./CustomService.vue?vue&type=style&index=1&id=437dca3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437dca3f",
  null
  
)

export default component.exports